import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import BASE_QUERY from '@/features/baseQuery';

// Creating an API service using RTK Query
export const propertiesApi = createApi({
	reducerPath: 'propertiesApi',
	tagTypes: ['PROPERTIES'],
	baseQuery: fetchBaseQuery(BASE_QUERY),
	endpoints: (builder) => ({
		// Defining an endpoint to get client industry property
		getIndustries: builder.query({
			providesTags: (result, error, arg) => [{ type: 'PROPERTIES', id: 'industries' }],
			query: () => ({
				url: process.env.REACT_APP_GET_CLIENT_INDUSTRIES,
				method: 'POST',
			}),
			transformResponse: (response) => {
				console.log('👾 ~ Transform getIndustries data', response);
				return response;
			},
		}),
		insightAnzsicCodeSearch: builder.query({
			providesTags: (result, error, arg) => [{ type: 'PROPERTIES', id: 'anzsicCodes' }],
			query: ({ searchQuery }) => ({
				url: process.env.REACT_APP_SEARCH_ANZSIC_CODE,
				method: 'POST',
				body: { searchQuery },
			}),
			transformResponse: (response) => {
				console.log('👾 ~ Transform get AnzsicCodeSearch data', response);
				return response;
			},
		}),
		insightListSourceOfBusiness: builder.query({
			providesTags: (result, error, arg) => [{ type: 'PROPERTIES', id: 'sourceOfBusiness' }],
			query: () => ({
				url: process.env.REACT_APP_SOURCE_OF_BUSINESS,
				method: 'POST',
			}),
			transformResponse: (response) => {
				console.log('👾 ~ Transform list source of business data', response);
				return response;
			},
		}),
		insightEndpoint: builder.query({
			providesTags: (result, error, arg) => [{ type: 'PROPERTIES', id: arg.endpoint }],
			query: ({ endpoint, ...data }) => ({
				url: `${process.env.REACT_APP_MISC_API_ENDPOINT}/v1${endpoint}`,
				method: 'POST',
				body: data,
			}),
			transformResponse: (response) => {
				// console.log('👾 ~ Transform insightEndpoint data', response);
				return response;
			},
			transformErrorResponse: (error) => {
				console.error('Error with insightEndpoint data', error);
				return error;
			},
		}),
	}),
});

// Exporting auto-generated hooks for the defined endpoints
export const {
	useGetIndustriesQuery,
	useInsightAnzsicCodeSearchQuery,
	useInsightListSourceOfBusinessQuery,
	useInsightEndpointQuery,
	useLazyInsightEndpointQuery,
} = propertiesApi;
